import { useEffect } from "react";
import { faqData } from "../../../mocks/fortyone";

export default function SchemaOrg() {
  useEffect(() => {
    const schemas = [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "四一爆料",
        url: "https://ai220.cn/",
        description: "四一爆料历史合集与时间线汇总，按事件顺序整理往期系列与回看脉络。",
        inLanguage: "zh-CN",
      },
      {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "四一爆料历史合集与时间线汇总",
        url: "https://ai220.cn/",
        inLanguage: "zh-CN",
        about: "四一爆料合集、汇总、历史时间线与系列回看",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqData.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ];
    const nodes = schemas.map((s) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.text = JSON.stringify(s);
      return el;
    });
    nodes.forEach((n) => document.head.appendChild(n));
    return () => nodes.forEach((n) => n.remove());
  }, []);

  return null;
}